var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "appfade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.appIsLoaded,
            expression: "appIsLoaded"
          }
        ],
        staticClass: "intro-page--template page-template"
      },
      [
        _c("div", { staticClass: "intro-bg" }, [
          _c("div", { staticClass: "db relative center w-100 vh-100" }, [
            _c(
              "div",
              {
                staticClass:
                  "db absolute left-0 right-0 center tc abs-vert-center"
              },
              [
                _c("router-link", {
                  staticClass: "bb pointer",
                  attrs: { to: "/home/" }
                })
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }